import $ from 'jquery';
import { showResizeImageDialog } from './showResizeImageDialog';
import { getState } from '~src/state';

export function initResizeListeners() {
  $('body').on('click', '#editor-menu-image-resize', async (event) => {
    event.preventDefault();

    let activeObject = getState('activeObject');
    if (activeObject.type === 'MagicFrame') {
      activeObject = activeObject.editingImg;
      if (!activeObject) {
        return;
      }
    }
    if (!activeObject || activeObject.type !== 'image') {
      return;
    }

    await showResizeImageDialog();
  });
}
